import { css } from "@emotion/react";

export const styles = {
  iconWrapper: css`
    border: 1px solid var(--primary-color);
    border-radius: 10%;
    height: var(--spacing-32);
    width: var(--spacing-48);
    cursor: pointer;
    display: flex;
    justify-content: center;
    --icon-fill-color: var(--color-splash-primary);
  `,
  iconLeft: css`
    border-top-right-radius: inherit;
    border-bottom-right-radius: inherit;
    align-items: center;
  `,
  iconRight: css`
    border-top-left-radius: inherit;
    border-bottom-left-radius: inherit;
    border-left: none;
    align-items: center;
  `,
  toggleButton: css`
    display: flex;
  `,
  selected: css`
    background-color: var(--ghost-focus);
  `
};
